export const getDepartmentName = (department: string[]) => {
  if (department.length === 2) {
    return "행정실";
  }

  if (department[0] === "life") {
    return "생활스포츠지도사";
  }
  if (department[0] === "pro") {
    return "전문스포츠지도사";
  }

  return "";
};
